/* tslint:disable */
/* eslint-disable */
/**
 * Backoffice Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    IamUserRole,
    IamUserRoleFromJSON,
    IamUserRoleFromJSONTyped,
    IamUserRoleToJSON,
} from './';

/**
 * 
 * @export
 * @interface ListIamUserRolesResponse
 */
export interface ListIamUserRolesResponse {
    /**
     * 
     * @type {Array<IamUserRole>}
     * @memberof ListIamUserRolesResponse
     */
    iamUserRoles?: Array<IamUserRole>;
}

export function ListIamUserRolesResponseFromJSON(json: any): ListIamUserRolesResponse {
    return ListIamUserRolesResponseFromJSONTyped(json, false);
}

export function ListIamUserRolesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListIamUserRolesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'iamUserRoles': !exists(json, 'iamUserRoles') ? undefined : ((json['iamUserRoles'] as Array<any>).map(IamUserRoleFromJSON)),
    };
}

export function ListIamUserRolesResponseToJSON(value?: ListIamUserRolesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'iamUserRoles': value.iamUserRoles === undefined ? undefined : ((value.iamUserRoles as Array<any>).map(IamUserRoleToJSON)),
    };
}


